import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import Notification from 'bundles/notification-center/components/Notification';
import type {
  EnterpriseContentAssignmentNotification as EnterpriseContentAssignmentNotificationType,
  Notification as NotificationType,
} from 'bundles/notification-center/types';

import _t from 'i18n!nls/notification-center';

type Props = {
  notification: EnterpriseContentAssignmentNotificationType;
  onClick: (notification: NotificationType) => void;
};

const EnterpriseContentAssignmentNotification: React.FC<Props> = ({ notification, onClick }) => (
  <Notification
    onClick={onClick}
    href={notification.data.programContentDeepLinkUrl || notification.data.xdpUrl}
    notification={notification}
  >
    {notification.data.courseName || notification.data.contentName ? (
      <FormattedHTMLMessage
        message={_t('<b>{adminName}</b> assigned you <b>{contentName}</b>.')}
        adminName={notification.data.adminName}
        contentName={notification.data.courseName || notification.data.contentName}
        tagName="span"
      />
    ) : (
      <FormattedHTMLMessage
        message={_t(`<b>{adminName}</b> assigned you content.`)}
        adminName={notification.data.adminName}
        tagName="span"
      />
    )}
  </Notification>
);

export default EnterpriseContentAssignmentNotification;
